// ./src/utils/browserHelpers.ts
import { UAParser } from "ua-parser-js";

// Parse user agent string
export const parseUserAgent = (
  userAgent: string | null | undefined
): { browser: string; os: string; device: string } => {
  if (!userAgent) {
    return { browser: "Unknown", os: "Unknown", device: "Unknown" };
  }

  try {
    const parser = new UAParser(userAgent);
    const result = parser.getResult();

    const browser = result.browser.name
      ? `${result.browser.name} ${result.browser.version || ""}`
      : "Unknown";

    const os = result.os.name
      ? `${result.os.name} ${result.os.version || ""}`
      : "Unknown";

    const device =
      result.device.vendor || result.device.model
        ? `${result.device.vendor || ""} ${result.device.model || ""}`.trim()
        : result.device.type || "Desktop";

    return { browser, os, device };
  } catch {
    return { browser: "Unknown", os: "Unknown", device: "Unknown" };
  }
};
